'use strict';

module.exports = /* @ngInject */ function() {
	return {
		restrict: 'E',
		scope: {
			referenceType: '<',
			articleReferences: '<',
			elementSelected: '<',
			uniteSupplier: '<',
			uniteCustomer: '<',
		},
		templateUrl: `./${BUILD_PATH}/unite.reference.article.directive.html`,
		controller: /* @ngInject */ function ($scope, uniteService) {
			
			$scope.references = {
				data: [],
				display: []
			};
			$scope.referencesLoading = false;

			$scope.referencesLoadNext = referencesLoadNext;
			$scope.referencesLoadPrevious = referencesLoadPrevious;

			var tempRefArticle = {
				loading: true,
				manufacturerName: '',
				headline: '',
				image: '',
				footer: '',
				index: null,
				article: null
			};

			var loadingReferencesNextOrPrevious = false;

			init();

			/**
			 * Function to be executed on init. Generates the button objects and destructively
			 * fills the $scope.buttons variable
			 */
			function init(){
				if($scope.referenceType && $scope.articleReferences){
					$scope.references.data = $scope.articleReferences.filter(function(ref){
						return ref.articleReferenceType === $scope.referenceType;
					});
					if($scope.references.data.length > 0){
						initReferenceArticles();
					}
				}
			}

			/**
			 * initializes reference articles if the current article has any.
			 * @returns {Promise<void>}
			 */
			async function initReferenceArticles(){
				$scope.referencesLoading = true;
				var refArticles = $scope.references.data;
				var index = 0;
				for(var i = 0; i < (refArticles.length >= 3 ? 3 : refArticles.length); i++){
					if(refArticles[index]){
						$scope.references.display[i] = tempRefArticle;
						try {
							$scope.references.display[i] = await loadReferenceAricle(refArticles, index);
							index = $scope.references.display[i].index + 1;
						} catch (e) {
							$scope.references.display.splice(i, 1);
						}
					} else {
						break;
					}
				}
				$scope.referencesLoading = false;
				$scope.$apply();
			}

			/**
			 * loads a specific reference article
			 * @param refArticles
			 * @param index
			 * @param reverse
			 * @returns {Promise<any>}
			 */
			function loadReferenceAricle(refArticles, index, reverse){
				return new Promise( function(resolve, reject){
					uniteService.getArticleById.get({
						articleId: refArticles[index].refId,
						supplier: $scope.uniteSupplier,
						customer: $scope.uniteCustomer
					}).$promise.then(function(article){
						var headline = article.descriptions[0].value;
						resolve({
							loading: false,
							manufacturerName: article.manufacturerName,
							headline: headline.length > 70 ? headline.substring(0, 70) + '...' : headline,
							image: article.mimeInfos !== null &&
							article.mimeInfos[0].href[0].value &&
							article.mimeInfos[0].href[0].value ?
								article.mimeInfos[0].href[0].value : '',
							footer: article.orderDetails.orderUnit.name + ' ' + uniteService.formatPrice(article.blockPricing[0]),
							index: index,
							article: article
						})
					}, function(){
						if($scope.references.data.length >= 3){
							var newIndex = !reverse ? index + 1 : index - 1;
							loadReferenceAricle(refArticles, newIndex).then(function(article){
								resolve(article)
							}, function (error) {
								reject(error);
							})
						} else {
							reject(null);
						}
					})
				})
			}

			/**
			 * fetches the next reference article in the reference list
			 * @returns {Promise<void>}
			 */
			async function referencesLoadNext() {
				if(!loadingReferencesNextOrPrevious){
					loadingReferencesNextOrPrevious = true;
					var refArticles = $scope.references.data;
					var middleElementInArray =
					$scope.references.display[$scope.references.display.length - 2];
					var lastDisplayedIndex = $scope.references.display[$scope.references.display.length - 1].index;
					var indexNewArticle = {
						data: refArticles[lastDisplayedIndex + 1] ? lastDisplayedIndex + 1 : 0,
						display: $scope.references.display.length - 1
					};
					var articleBackup = $scope.references.display.shift();
					$scope.references.display.push(tempRefArticle);
					try {
						$scope.references.display[indexNewArticle.display] = await loadReferenceAricle(refArticles, indexNewArticle.data);
					} catch (e) {
						$scope.references.display.pop();
						$scope.references.display.unshift(articleBackup);
					} finally {
						stopLoadingNextOrPrevious();
					}
				}
			}

			/**
			 * loads the previous reference article
			 * @returns {Promise<void>}
			 */
			async function referencesLoadPrevious() {
				if(!loadingReferencesNextOrPrevious){
					loadingReferencesNextOrPrevious = true;
					var refArticles = $scope.references.data;
					var firstDisplayedIndex = $scope.references.display[0].index;
					var indexNewArticle = {
						data: refArticles[firstDisplayedIndex - 1] ? firstDisplayedIndex - 1 : refArticles.length - 1,
						display: 0
					};
					var articleBackup = $scope.references.display.pop();
					$scope.references.display.unshift(tempRefArticle);
					try {
						$scope.references.display[indexNewArticle.display] = await loadReferenceAricle(refArticles, indexNewArticle.data, true);
					} catch (e) {
						$scope.references.display.shift();
						$scope.references.display.push(articleBackup);
					} finally {
						stopLoadingNextOrPrevious();
					}
				}
			}

			function stopLoadingNextOrPrevious(){
				$scope.$apply();
				loadingReferencesNextOrPrevious = false;
			}
		}
	};
}
